import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';import { Router } from '@angular/router';
import { ApiService } from "./api.service";
import { Mappings } from "../../shared/mapping";

@Injectable()
export class ValidationService {

    constructor
    (
        protected router: Router,
        protected _api: ApiService,
        protected mappings: Mappings
    ) {}

    //validation of phone numbers, disable writing any characters in input except of numbers    
    validatePhoneNumber(event: any)
    {
        const pattern = /[0-9]/;
        let inputChar = String.fromCharCode(event.charCode);
    
        if (!pattern.test(inputChar)) {
          // invalid character, prevent input
          event.preventDefault();
        }
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/validation.service.ts